module.exports = __webpack_public_path__ + "static/media/project_design_1_1.f19cd89b.webp";